import Copyright from "@/components/Copyright";
import { Container } from "@mui/material";
import { AppContext } from "@my-helpers/common";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Notification } from "@/components/Notification";
import { VerifyEmail } from "@/components/registration";

const Verify = () => {
    const navigate = useNavigate();
    const app = useContext(AppContext);
    if (!app) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    const { verifyEmail, clearError } = app.command;
    const { isLoading, error, sessionUser } = app.view;

    if (!sessionUser || sessionUser.emailVerified) {
        navigate('/signin');
    }

    return (
        <Container component="main" maxWidth={"xs"}>
            <VerifyEmail
                verifyEmail={verifyEmail}
                email={sessionUser?.email}
            />
            <Notification
                isLoading={isLoading}
                clearError={clearError}
                error={error}
                delay={300}
                autoHideDuration={1200}
            />
            <Copyright sx={{ mt: 5 }} />
        </Container>
    );
};

export default Verify;